import { useRouteColor } from "../hooks/useRouteColors";
import React from "react";

function PublicLayout({ children }) {
  const { bg } = useRouteColor();
  return (
    <div className={`transition-colors duration-500 ease-in-out ${bg}`}>
      {children}
    </div>
  );
}

export default PublicLayout;
